/* Vedicflora sub-collection sidebar widget.
 * Desktop (≥990px): move into filter sidebar
 * Mobile/tablet:   keep where it is (after grid section), just unhide
 */
(function(){
  function placeWidget(){
    var widget = document.getElementById('vf-sub-nav');
    if (!widget) return;

    // Always unhide
    if (widget.hasAttribute('hidden')) widget.removeAttribute('hidden');

    if (widget.dataset.vfPlaced === '1') return;

    var media = window.matchMedia('(min-width: 990px)');
    if (!media.matches) {
      // mobile: leave in place (bottom of page after grid). Just style as a section.
      widget.style.maxWidth = '1600px';
      widget.style.margin = '0 auto';
      widget.style.padding = '0 32px 32px';
      widget.dataset.vfPlaced = '1';
      return;
    }

    // Desktop: locate sidebar
    var target =
         document.querySelector('#main-collection-filters .facets-vertical')
      || document.querySelector('#main-collection-filters facet-filters-form')
      || document.querySelector('#main-collection-filters .facets')
      || document.querySelector('aside.facets-vertical')
      || document.querySelector('aside.facets')
      || document.querySelector('#main-collection-filters')
      || document.querySelector('aside');

    if (target) {
      // Prepend so the sub-nav appears ABOVE the filter widget in the sidebar.
      target.insertBefore(widget, target.firstChild);
      widget.dataset.vfPlaced = '1';
    }
  }

  function init(){
    placeWidget();
    var mo = new MutationObserver(function(){
      clearTimeout(window.__vfSubNavTimer);
      window.__vfSubNavTimer = setTimeout(placeWidget, 80);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function(){
      clearTimeout(window.__vfSubNavRz);
      window.__vfSubNavRz = setTimeout(function(){
        // On resize across breakpoint, allow re-placement
        var w = document.getElementById('vf-sub-nav');
        if (w) delete w.dataset.vfPlaced;
        placeWidget();
      }, 200);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
